import { render, staticRenderFns } from "./Sustainability.vue?vue&type=template&id=07d4056d&scoped=true&"
import script from "./Sustainability.vue?vue&type=script&lang=ts&"
export * from "./Sustainability.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d4056d",
  null
  
)

export default component.exports